import { Button, Step, StepLabel, Stepper } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import TableStyles from "./Table.module.css";
import styles from "./AppManage.module.scss";
import "./styles.scss";
import deletebtn from "../../../../Assets/applifecycle/deleteicon.svg";
import importantBtn from "../../../../Assets/Important.svg";
import releaseNotes from "../../../../Assets/applifecycle/release-notes.svg";

import FormikControl from "../../../../util/formcomponents/FormikControl";
import PrimaryButton, {
  SecondaryButton,
} from "../../../../util/Btns/PrimaryButton";
import ApkPicker from "../../../../util/graphic-picker/apk-picker";
import GraphicPicker from "../../../../util/graphic-picker/graphic-picker";
import ReleaseNotesModal from "../../../../components/consolecomponents/modal/ReleaseNotesModal";
import ForceUpdateModal from "../../../../components/consolecomponents/modal/ForceUpdateModal";
import DeleteBuildModal from "../../../../components/consolecomponents/modal/DeleteBuildModal";
import RemarksModal from "../../../../components/consolecomponents/modal/RemarksModal";
import StepConnector from "@material-ui/core/StepConnector";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import IsLoading from "../../../../util/loader/IsLoading";
import { useHistory } from "react-router-dom";
import {
  useBuildStatus,
  useGetCategoryList,
  usePublishBuild,
  useRepublishBuild,
  useReleaseApk,
  useUpdateAppStoreListing,
  useUploadGraphics,
  useUpdateAppstoreGraphics,
  useGetDebugProdKey,
  useUpdateAppDetails,
  useGetAppKeys,
  useAppConfig,
} from "../../../../hooks/DevAppHooks";
import { CustomToast } from "../../../../util/custom-toast/CustomToast";
import TextError from "../../../../util/formcomponents/TextError";
import {
  getAppStoreData,
  getStatus,
  sliceString,
} from "../../../../util/helpers/funcHelper";
import { appStatus, publishType } from "../../../../util/helpers/statusHelper";
import { generatedKeys, platform } from "../../../../util/helpers/objectHelper";
import UnpublishBuildModal from "../../../../components/consolecomponents/modal/UnpublishBuildModal";
import RollBack from "../../../../components/consolecomponents/modal/RollbackModal";
import CustomModal from "../../../../components/modal";
import StoreListingModal from "../../../../components/consolecomponents/modal/appManageStoreListing/StoreListingModal";
import copyBtn from "../../../../Assets/Copy_btn.svg";
import Andriod_Icon from "../../../../Assets/Andriod_Icon.svg";
import copy from "copy-to-clipboard";
import { FormikStepper } from "./FormikStrepper";
import ConsoleLocalStorage from "../../../../storage/storage";
import ReactTooltip from "react-tooltip";
import Info from "../../../../Assets/info.svg";
import { UploadCreatives } from "./UploadCreatives";

const stepTwoValidationSchema = Yup.object({
  graphics: Yup.object().shape({
    icon: Yup.array().of(
      Yup.object().shape({
        url: Yup.string().required("Required"),
      })
    ),
    banners: Yup.array().of(
      Yup.object().shape({
        url: Yup.string().required("Required"),
      })
    ),
  }),
});

const stepFourSubmit = async (values) => {
  // console.log(values);
};

const appType = [
  { key: "3D Application", value: "3D" },
  // { key: '2D Application', value: '2D' },
  // { key: 'Web Application', value: 'pwa' },
];

const forceUpdateConst = [
  { key: "Normal Update", value: 'false', info: 'Optional app update will allows users to choose whether or not to update' },
  { key: "Force Update", value: 'true', info: 'Mandatory app update will force user to update apps for the require updates' },
];

const controllerRequiredConstants = [
  { key: "Yes", value: "true" },
  { key: "No", value: "false" },
];

const interactionTypes = [
  { key: "Gaze & Click", value: "gaze-click" },
  { key: "Gaze & Dwell", value: "gaze-dwell" },
  // { key: "Jio Wand", value: "jio-wand" },
  { key: "Gaming Controller", value: "game-controller" },
  { key: "Virtual Controller", value: "virtual-controller" },
];

const ageOptions = [
  { key: "3 Years and above", value: "3" },
  { key: "7 Years and above", value: "7" },
  { key: "12 Years and above", value: "12" },
  { key: "16 Years and above", value: "16" },
  { key: "18 Years and above", value: "18" },
];

export default function AppManage({ step, app, isLoading, isError, match }) {
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
  const [showDeleteBuild, setShowDeleteBuild] = useState(false);
  const [showUnpublishBuild, setShowUnpublishBuild] = useState(false);
  const [showRollBackModal, setShowRollbackModal] = useState(false);
  const [build, setBuild] = useState(0);
  const [stepperCount, setStepperCount] = useState(step);

  const [forceUpdateInfo, setForceUpdateInfo] = useState({
    showUpdate: app?.builds?.[0]?.activeRelease?.packageCode ? "true" : "false",
    isForceUpdate: "false",
    showPopup: "false",
    minUpdVerCode: null,
    minUpdVerName: null
  });

  const setForceUpdateKey = (key, val) => {
    setForceUpdateInfo({ ...forceUpdateInfo, [key]: val })
  }
  const setShowForceUpModal = (val) => {
    setForceUpdateKey('showPopup', val)
  }
  const setForceUpdateVersion = (version) => {
    // setForceUpdateKey('minUpdVerCode',version.minUpdVerCode);
    // setForceUpdateKey('minUpdVerName',version.minUpdVerName);
    setForceUpdateInfo({ ...forceUpdateInfo, ...version, showPopup: false })
  }
  useEffect(() => {
    console.log("}}}}}}}}}}}}}}", forceUpdateInfo)

  }, [forceUpdateInfo])


  const imgArr = [];
  if (
    app &&
    app.builds &&
    app.build?.[0]?.graphics?.screenshots &&
    app.build?.[0]?.graphics?.screenshots.length
  ) {
    for (let i = 0; i < app.build?.[0]?.graphics?.screenshots.length; i++) {
      imgArr.push(i);
    }
  }

  const [moreImageCount, setMoreImageCount] = useState(
    imgArr.length ? imgArr : [0]
  );
  const [imagesUploaded, setImagesUploaded] = useState(
    imgArr.length ? imgArr : [0]
  );
  const [moreVideoCount, setMoreVideoCount] = useState(0);
  const [apkUploaded, setApkUploaded] = useState(false);
  const [iconUpload, setIconUpload] = useState(false);
  const [thumbnailUpload, setThumbnailUpload] = useState(false);
  const [smallBannerUpload, setSmallBannerUpload] = useState(false);
  const [largeBannerUpload, setLargeBannerUpload] = useState(false);
  const [showStoreListingModal, setShowStoreListingModal] = useState(false);
  const [appTypeValidation, setAppTypeValidation] = useState(true);
  const [storeListingUploadBuild, setStoreListingUploadBuild] = useState("");
  const [buildSkip, setBuildSkip] = useState(false);
  const [storeListingValues, setStoreListingValues] = useState();
  const [appStoreGraphicsData, setAppStoreGraphicsData] = useState();
  const history = useHistory();
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [keyType, setKeyType] = useState("debug");
  const [keyData, setKeyData] = useState();
  const [generatedKeyValue, setGeneratedKeyValue] = useState();
  const [stepThreeValues, setStepThreeValue] = useState();
  const [buildValue, setBuildValue] = useState();
  const [screenshotUpload, setScreenshotUpload] = useState([]);
  // const email = query.get('email');
  const { data: categoryOptions } = useGetCategoryList(
    "app",
    app.platform,
    app.appOS
  );
  const { data: configData } = useAppConfig(
    ConsoleLocalStorage.getOrganization().tags
  );

  const ref = useRef(null);

  let buildArr = [];

  if (app?.builds && app?.builds?.length === 0) {
    buildArr = app?.supportedPlatforms?.map((el) => {
      let t = { platform: el };
      return t;
    });
  } else {
    buildArr = app?.builds;
  }
  const initialValues = {
    title: app.title,
    platform: app?.supportedPlatforms,
    appType: app.activity,
    controllerRequired: app?.controllerRequired
      ? app?.controllerRequired.toString()
      : "false",
    interactionType:
      app?.interactionType?.length > 0 ? app?.interactionType : ["gaze-click"],
    appOS: app?.appOS,
    generateKeyType: "debug",
    generatedKey: "",
    appSign: app?.appSign,
    playstoreUrl: app?.storeData ? app?.storeData[0]?.url : "",
    packageName: app.packageName,
    domainName: app.domainName,
    category: app?.category?._id,
    shortDescription: app.shortDescription,
    description: app.description,
    ageRating: app.ageRating,
    languages: app.languages.toString(),
    privacyPolicy: app.privacyPolicy,
    builds: buildArr,
    createRelease: {
      url: "",
      version: "",
      releaseNote: "",
      size: 1024,
      forceUpdate: 'false'
    },
    deepLink: app?.builds?.[0]?.activeRelease?.storeData?.filter(
      (a) => a.id === (app.appOS === "ios" ? "ios-intent" : "android-intent")
    )?.[0]?.url,
  };
  const allScreenShots = {};
  app?.supportedPlatforms?.forEach((plat) => {
    let index = app?.builds?.findIndex((build) => build?.platform === plat);
    if (index > -1) {
      allScreenShots[plat] = app?.builds[index];
    }
  });

  useEffect(() => {
    if (app.builds?.[0]?.graphics?.appIcon?.url) setIconUpload(true);
    if (app.builds?.[0]?.graphics?.thumbnail?.url) setThumbnailUpload(true);
    if (app.builds?.[0]?.graphics?.bannerSmall?.url) setSmallBannerUpload(true);
    if (app.builds?.[0]?.graphics?.bannerLarge?.url) setLargeBannerUpload(true);
    let minLengthOfScreenshot = [];
    buildArr?.forEach((item) => {
      let temp =
        item?.graphics?.screenshots?.filter((ele) => ele.url !== "") ?? 0;
      let len = temp ? temp?.length : 0;
      minLengthOfScreenshot.push(len);
    });
    setScreenshotUpload(minLengthOfScreenshot);
    app.appType !== "pwa"
      ? setAppTypeValidation(true)
      : setAppTypeValidation(false);
  }, []);

  const stepOneValidationSchemaPackage = Yup.object({
    packageName: Yup.string()
      .required("Required")
      .matches(
        /^[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        `Invalid ${app?.appOS === "ios" ? "package name" : "bundle id"}`
      ),
  });
  const stepOneValidationSchemaDomain = Yup.object({
    domainName: Yup.string()
      .required("Required")
      .matches(
        /^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$/,
        "Invalid domain name"
      ),
  });

  const stepOneCommonValidationSchema = Yup.object({
    title: Yup.string()
      .min(3, "Minimum 3 characters required")
      .required("Required")
      .matches(
        /^([A-Za-z0-9 ]*[A-Za-z]){3,}[A-Za-z0-9 '-]*$/,
        "Invalid Application name"
      ),
    appSign: app.appOS === "android" ? Yup.string().required("Required") : "",
    appType: Yup.string().required("Required"),
    controllerRequired: Yup.string().required("Required"),
    interactionType: Yup.array().min(1, "Required").required("Required"),
    category: Yup.string().required("Required"),
    shortDescription: Yup.string()
      .min(10, "Minimum 10 characters required")
      .required("Required"),
    description: Yup.string()
      .min(20, "Minimum 20 characters required")
      .required("Required"),
    ageRating: Yup.string().required("Required"),
    languages: Yup.string()
      .min(3, "Minimum 3 characters required")
      .required("Required"),
    privacyPolicy: Yup.string()
      .min(4, "Minimum 4 characters required")
      .required("Required")
      .matches(
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        "Invalid Website URL"
      ),
  });
  const stepOneValidationSchema = appTypeValidation
    ? stepOneCommonValidationSchema.concat(stepOneValidationSchemaPackage)
    : stepOneCommonValidationSchema.concat(stepOneValidationSchemaDomain);

  // const stepThreeValidationSchemaDomain = Yup.object().shape({
  //   createRelease: Yup.object().shape({
  //     url: Yup.string().matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, "Invalid URL").required('Required'),
  //   }),
  // });

  const stepThreeValidationSchema = Yup.object().shape({
    createRelease: Yup.object().shape({
      version: Yup.string()
        .min(3, "Minimum 3 characters required")
        .required("Required"),
      releaseNote: Yup.string()
        .min(20, "Minimum 20 characters required")
        .required("Required"),
      url: Yup.string()
        .matches(/^(https:\/)(:[0-9]{1,5})?(\/.*)?$/i, "Invalid URL")
        .required("Required"),

    }),
    playstoreUrl: Yup.string()
      .min(3, "Minimum 3 characters required")
      .required("Required"),
    deepLink: Yup.string()
      .max(256, "Maximum 256 characters allowed")
      .when(app.appOS, {
        is: "ios",
        then: Yup.string()
          .min(3, "Minimum 3 characters required")
          .required("Required"),
        otherwise: Yup.string(),
      }),
  });

  useEffect(() => {
    setApkUploaded(false);
    setGeneratedKeyValue("");
    setKeyType("debug");
  }, [step]);

  useEffect(() => {
    setKeyData();
    getAppKeys();
    setGeneratedKeyValue("");
  }, [keyType]);

  const { mutate: getAppKeys, data } = useGetAppKeys(app.id, keyType);

  // const stepThreeValidationSchema = !appTypeValidation ? stepThreeValidationSchemaCommon.concat(stepThreeValidationSchemaDomain) : stepThreeValidationSchemaCommon;

  /**
   * Step 1
   */
  const {
    mutate: updateStoreListingMutate,
    isSuccess: isUpdateStoreListingSuccess,
  } = useUpdateAppStoreListing(app.id);

  const stepOneSubmit = async (values) => {
    const obj = {
      ...values,
      platform: values?.platform?.length
        ? values.platform
        : initialValues.platform,
      appOS: app?.appOS,
    };
    updateStoreListingMutate(obj); // navigation to the next step only happens if the update is success (logic below useEffect)
    setGeneratedKeyValue("");
    setKeyType("debug");
  };

  useEffect(() => {
    if (isUpdateStoreListingSuccess) {
      // updated successfully moved to the next step generate keys
      setStepperCount(1);
    }
  }, [isUpdateStoreListingSuccess]); // get called whenever updating storeListing data via updateStoreListingMutate

  const { mutate: getDebugProdKeyMutate, data: key } = useGetDebugProdKey();
  const { mutate: updateAppDetailsMutate, isSuccess: isSuccessOfUpdateApp } =
    useUpdateAppDetails(app.id);

  const appDetailsSubmit = async (values) => {
    updateAppDetailsMutate(values);
  };

  const keyDetailsSubmit = async (values) => {
    const obj = {
      signature: values?.appSign,
      appId: app.id,
      stage: values?.generateKeyType.toUpperCase(),
    };
    getDebugProdKeyMutate(obj);
  };

  useEffect(() => {
    if (key?.data?.data?.hash) {
      setGeneratedKeyValue(key.data.data.hash);
    }
  }, [key]);

  useEffect(() => {
    if (data?.data?.data) {
      setKeyData(data.data.data);
    }
  }, [data]);

  const keyGenerationStepperSubmit = async (values) => {
    setGeneratedKeyValue("");
    getAppKeys();
  };

  /**
   * Step 2
   */
  const { mutate: uploadGraphicsMutate } = useUploadGraphics(app.id);
  const { mutate: updateAppstoreGraphics } = useUpdateAppstoreGraphics();

  const [isApplyAsAboveChecked, setIsApplyAsAboveChecked] = useState(false);

  const stepTwoSubmit = async (values) => {
    // values = values ? values : storeListingValues;

    // let data = {
    //   id: app.id,
    //   data: {
    //     graphics: values.graphics,
    //   },
    // };
    // let finalData = {};

    // let buildsList = values?.builds?.map((el) => {
    //   let list = el?.graphics?.screenshots?.filter((item) => item?.url !== "");
    //   return { ...el, graphics: { ...el.graphics, screenshots: list } };
    // });

    // values?.platform?.forEach((plat, index) => {
    //   let temp = {
    //     appIcon: buildsList[0]?.graphics.appIcon,
    //     bannerLarge: buildsList[0]?.graphics.bannerLarge,
    //     bannerSmall: buildsList[0]?.graphics.bannerSmall,
    //     thumbnail: buildsList[0]?.graphics.thumbnail,
    //     screenshots: buildsList[index]?.graphics.screenshots ?? [],
    //   };
    //   finalData[plat] = temp;
    // });

    // data.data.graphics.screenshots = values.graphics.screenshots.filter(
    //   (ss) => ss.url !== "" && ss.url !== undefined
    // );
    // setAppStoreGraphicsData(data);
    // if (storeListingUploadBuild === "uploadBuild") {
    //   if (Object.keys(finalData)?.length !== 0) {
    //     uploadGraphicsMutate(finalData);
    //   }
    //   if (app?.activeRelease) {
    //     updateAppstoreGraphics(finalData);
    //   }
    //   history.push(`${match.url}/release-management`);
    // } else if (storeListingUploadBuild === "publishStore") {
    //   setStoreListingValues(finalData);
    // }
    if (storeListingUploadBuild !== "publishStore") {
      if (Object.keys(storeListingValues)?.length !== 0) {
        uploadGraphicsMutate(storeListingValues);
      }
      history.push(`${match.url}/release-management`);
    }
  };

  const setPublishStoreData = async () => {
    setShowStoreListingModal(true);
    setBuildSkip(true);
    setStoreListingUploadBuild("publishStore");
  };
  // const setUploadBuildData = async () => {
  //   setShowStoreListingModal(false);
  //   setStoreListingUploadBuild("uploadBuild");
  // };

  /**
   * Step 3
   */
  const { mutate: releaseAppMutate } = useReleaseApk(app.id);

  const stepThreeSubmit = async (values) => {
    releaseAppMutate({
      ...values?.createRelease,
      ...(forceUpdateInfo.minUpdVerCode && { minUpdVerCode: forceUpdateInfo.minUpdVerCode }),
      ...(forceUpdateInfo.minUpdVerName && { minUpdVerName: forceUpdateInfo.minUpdVerName }),
      storeData: getAppStoreData({
        playstoreUrl: values?.playstoreUrl,
        appOS: app?.appOS,
        appSign: initialValues.appSign,
        deepLink: values?.deepLink,
      }),
    });
    setStepThreeValue({
      ...values, ...(forceUpdateInfo.minUpdVerCode && { minUpdVerCode: forceUpdateInfo.minUpdVerCode }),
      ...(forceUpdateInfo.minUpdVerName && { minUpdVerName: forceUpdateInfo.minUpdVerName }),
    });
  };

  // useEffect(() => {
  //   if (isSuccessOfUpdateApp) {
  //     releaseAppMutate(stepThreeValues);
  //   }
  // }, [isSuccessOfUpdateApp]);

  /**
   * Step 4
   */

  const { mutate: publishBuildMutate } = usePublishBuild();
  const { mutate: republishBuildMutate } = useRepublishBuild();
  const handlePublish = (releaseid) => {
    publishBuildMutate(releaseid);
  };

  const handleRepublish = (releaseid, _publishType) => {
    // updateAppDetailsMutate(values);
    republishBuildMutate({ releaseid, publishType: _publishType });
  };

  const {
    data: buildStatusData,
    isLoading: buildStatusLoading,
    isError: buildStatusError,
  } = useBuildStatus(app.id);

  if (isLoading || buildStatusLoading) {
    return <IsLoading />;
  }
  if (isError || buildStatusError) {
    history.push("/login");
    return <IsLoading />;
  }

  const handleModal = (e) => {
    if (e.target.value === "ios") {
      setShowComingSoon(true);
    } else {
      setShowComingSoon(false);
    }
  };

  const copyTextToClipboard = (value) => {
    copy(value);
  };

  return (
    <>
      <ReleaseNotesModal
        showReleaseNotes={showReleaseNotes}
        setShowReleaseNotes={setShowReleaseNotes}
        build={build}
      />
      <ForceUpdateModal
        showForceUpModal={forceUpdateInfo.showPopup}
        setShowForceUpModal={setShowForceUpModal}
        buildStatusData={buildStatusData.filter((v) =>
          [appStatus.release.activated.status, appStatus.release.approved.status].includes(v.status) && v.packageCode
        )}
        setForceUpdateVersion={setForceUpdateVersion}
        forceUpdateInfo={forceUpdateInfo}
        app={app}
      />
      <RemarksModal
        showRemarks={showRemarks}
        setShowRemarks={setShowRemarks}
        build={build}
      />
      <DeleteBuildModal
        showDeleteBuild={showDeleteBuild}
        setShowDeleteBuild={setShowDeleteBuild}
        build={build}
      />
      <CustomModal
        showModal={showRollBackModal}
        setShowModal={setShowRollbackModal}
        rootClassName={"default"}
        size="md"
        build={build}
        title={` Rollback to Version ${build.apkVersionName}`}
      >
        <RollBack
          showModal={showRollBackModal}
          setShowModal={setShowRollbackModal}
          build={build}
        />
      </CustomModal>

      <UnpublishBuildModal
        showUnpublishBuild={showUnpublishBuild}
        setShowUnpublishBuild={setShowUnpublishBuild}
        build={build}
      />
      {storeListingValues && (
        <StoreListingModal
          showStoreListingModal={showStoreListingModal}
          setShowStoreListingModal={setShowStoreListingModal}
          setBuildSkip={setBuildSkip}
          setStoreListingUploadBuild={setStoreListingUploadBuild}
          storeListingValues={storeListingValues}
          appStoreGraphicsData={appStoreGraphicsData}
          match={match}
          app={app}
          handleBuildAsWell={stepTwoSubmit}
        />
      )}

      <FormikStepper
        initialValues={initialValues}
        app={app}
        // stepCnt={step}
        stepCnt={stepperCount}
        modalFlag={showStoreListingModal}
        buildSkipFlag={buildSkip}
        ref={ref}
      >
        <FormikStep
          label="App Information"
          validationSchema={stepOneValidationSchema}
          onSubmit={stepOneSubmit}
        >
          <div className={styles.stepContainer}>
            <FormikControl
              control="iconCheckbox"
              isRow={true}
              options={app?.appOS !== "ios" ? configData?.platform?.android : configData?.platform?.ios}
              label="Platform"
              name="platform"
              required
              selectedList={initialValues.platform}
              handleModal={(e) => {
                e.preventDefault();
              }}
              handleChange={(e) => {
                e.preventDefault();
              }}
            />

            <FormikControl
              control="input"
              type="text"
              maxLen="30"
              label="Application Name"
              name="title"
            // onChange={onChange}
            />

            <FormikControl
              control="radio"
              isRow={true}
              disabled
              options={appType}
              required
              label="Application type"
              name="appType"
            />

            <FormikControl
              control="radio"
              options={controllerRequiredConstants}
              required
              label="Is Controller Required for this Application"
              name="controllerRequired"
            />

            <FormikControl
              control="checkbox"
              isRow={true}
              options={interactionTypes}
              label="Select interaction type experience for the app"
              name="interactionType"
            />

            {app.appType === "pwa" ? (
              <FormikControl
                control="input"
                type="text"
                maxLen="2000"
                disabled
                label="Domain Name"
                name="domainName"
              />
            ) : null}
            {app.appOS === "android" ? (
              <FormikControl
                control="input"
                type="text"
                disabled
                maxLen="60"
                label="Package Name"
                name="packageName"
              />
            ) : (
              <FormikControl
                control="input"
                type="text"
                disabled
                maxLen="60"
                label="Bundle ID"
                name="packageName"
              />
            )}

            {!app.appOS || app.appOS === "android" ? (
              <FormikControl
                control="input"
                type="text"
                maxLen="300"
                label="Application Signature"
                name="appSign"
                tooltip="Please provide the play store signature details."
              />
            ) : null}

            <label className="xs-lable-select white" required>
              Which Appstore category does your application belong to?
              <span style={{ color: "red" }}>{` *`}</span>
            </label>
            <div className="category_list" disabled>
              {categoryOptions && (
                <Field name={"category"}>
                  {({ field: { value }, form: { setFieldValue } }) => {
                    return (
                      categoryOptions &&
                      categoryOptions.map((option) => {
                        return (
                          <div className="category_container" key={option.name}>
                            <div
                              className={`${styles.category_box} category_box ${value === option._id
                                  ? "category_box_active"
                                  : ""
                                }`}
                              onClick={() =>
                                setFieldValue("category", option._id)
                              }
                            >
                              <img
                                width="20px"
                                src={option.devIcon}
                                alt="category-icon"
                              />
                            </div>
                            <span
                              className={`category_title ${value === option._id
                                  ? "category_title_active"
                                  : ""
                                }`}
                            >
                              {option.name}
                            </span>
                          </div>
                        );
                      })
                    );
                  }}
                </Field>
              )}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className=""></div>
                <ErrorMessage component={TextError} name={"category"} />
              </div>
            </div>

            <FormikControl
              maxLen="200"
              rows="5"
              control="textarea"
              autoComplete="nope"
              label="Short Description"
              required={true}
              name="shortDescription"
            />

            <FormikControl
              maxLen="2000"
              rows="8"
              control="textarea"
              autoComplete="nope"
              label="Long Description"
              required={true}
              name="description"
            />

            <FormikControl
              control="radio"
              options={ageOptions}
              required={true}
              label="Age Criteria?"
              name="ageRating"
            />

            <FormikControl
              control="input"
              type="text"
              maxLen="100"
              // required={false}
              label="Language Support"
              name="languages"
            />

            <FormikControl
              control="input"
              type="text"
              maxLen="260"
              // required={false}
              label="Privacy Policy"
              name="privacyPolicy"
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1em",
              }}
              className=""
            >
              {/* <PrimaryButton style={{ width: "13em" }}> // commented this button to prevent the default navigation and added new button
                Save and Proceed
              </PrimaryButton> */}
              {/* added field to get the current values of the form */}
              <Field name="saveAndProceed">
                {({ field, form: { values } }) => (
                  <button
                    type="submit"
                    className="primary-btn"
                    // onClick={() => stepOneSubmit(values)} // passing the current formData(values) to submit function
                    style={{ width: "13em" }}
                  >
                    Save and Proceed
                  </button>
                )}
              </Field>
            </div>
          </div>
        </FormikStep>

        {initialValues?.packageName !== "" && (
          <FormikStep
            label="Generated Keys"
            setKeyType={setKeyType}
            // validationSchema={keyValidationSchema}
            onSubmit={keyGenerationStepperSubmit}
          >
            <div className={`${styles.stepContainer} step-container`}>
              <Field name="generateKeyType">
                {({ field, form: { setFieldValue } }) => {
                  return (
                    <>
                      <FormikControl
                        control="iconRadio"
                        isRow={true}
                        options={generatedKeys}
                        label=""
                        name="generateKeyType"
                        showOnlyActive={false}
                        handleModal={handleModal}
                        handleChange={(e) => {
                          e.preventDefault();
                        }}
                      />
                      <div className="debug-key">
                        Your {field.value === "debug" ? "Debug" : "Production"}{" "}
                        key
                      </div>
                    </>
                  );
                }}
              </Field>

              <Field name="generatedKey">
                {({ field, form: { values, setFieldValue } }) => {
                  const generateKeyTypeFieldValue = values.generateKeyType;
                  setKeyType(generateKeyTypeFieldValue);
                  return (
                    <>
                      <div style={{ position: "relative" }}>
                        <FormikControl
                          control="input"
                          value={generatedKeyValue} //get value from api and set to state
                          type="text"
                          label="Generated Key"
                          disabled
                          name="generatedKey"
                        />

                        <div
                          className="copy-img"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {!generatedKeyValue ? (
                            <Button
                              className="debug-prod-key"
                              onClick={() => keyDetailsSubmit(values)}
                              style={{
                                backgroundColor: "#4096ef",
                                position: "absolute",
                                bottom: "0",
                                marginBottom: "2.5rem",
                                width: "166px",
                                marginLeft: "-4rem",
                                height: "30px",
                                color: "#FFFFFF",
                                fontFamily: "JioType-Medium",
                                fontSize: "11px",
                              }}
                            >
                              Get{" "}
                              {generateKeyTypeFieldValue === "debug"
                                ? "Debug"
                                : "Production"}{" "}
                              Key
                            </Button>
                          ) : (
                            <img
                              src={copyBtn}
                              className="copy-img"
                              alt="logo"
                              style={{
                                width: "5rem",
                                height: "2rem",
                                cursor: "pointer",
                                margin: "0.25rem",
                                position: "absolute",
                                bottom: "0",
                                marginBottom: "2.5rem",
                                marginLeft: "-4rem",
                              }}
                              onClick={() => {
                                copyTextToClipboard(generatedKeyValue);
                                CustomToast(
                                  "Generated key copied to clipboard!"
                                );
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          color: "#4096EF",
                          float: "left",
                        }}
                        className=""
                      >
                        <a
                          target="_blank"
                          href="https://docs.tesseract.in/develop/v/v4.34/publish/licensing-journey-in-jioimmerse"
                          rel="noreferrer"
                        >
                          How do I use this ?
                        </a>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "1em",
                        }}
                        className=""
                      >
                        <PrimaryButton
                          disabled={
                            generatedKeyValue || (keyData && keyData[0]?.hash)
                              ? false
                              : true
                          }
                          style={{ width: "192px" }}
                        >
                          Save and Proceed
                        </PrimaryButton>
                      </div>

                      {keyData && (
                        <table className={TableStyles.table}>
                          <thead>
                            <tr>
                              <th style={{ width: "10%", textAlign: "center" }}>
                                Platform
                              </th>
                              <th style={{ width: "77%", textAlign: "center" }}>
                                Generated Key
                              </th>
                              <th
                                style={{ width: "10%", textAlign: "center" }}
                              ></th>
                            </tr>
                          </thead>
                          <tbody>
                            {keyData.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  <img
                                    src={
                                      app?.appOS === "ios"
                                        ? configData?.osList[1]?.icon
                                        : configData?.osList[0]?.icon
                                    }
                                    className={TableStyles.androidImg}
                                    alt="Android"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className={`${TableStyles.forminput} ${item.hash.length > 50
                                        ? `${TableStyles.truncatetext}`
                                        : ""
                                      }`}
                                    disabled
                                    value={item.hash}
                                    title={item.hash}
                                  />
                                </td>
                                <td>
                                  <img
                                    src={copyBtn}
                                    className={TableStyles.copyImg}
                                    alt="Copy"
                                    onClick={() => {
                                      copyTextToClipboard(item.hash);
                                      CustomToast(
                                        "Generated key copied to clipboard!"
                                      );
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </>
                  );
                }}
              </Field>
            </div>
          </FormikStep>
        )}

        <UploadCreatives
          label="Upload Creatives" // for stepper label
          id={app?.id}
          initialValues={initialValues}
          setPublishStoreData={setPublishStoreData}
          storeListingUploadBuild={storeListingUploadBuild}
          match={match}
          setStoreListingValues={setStoreListingValues}
          onSubmit={() => history.push(`${match.url}/release-management`)}
        />

        <FormikStep
          label={
            initialValues.appType !== "pwa" ? "Upload Build" : "Submit URL"
          }
          setApkUploaded={setApkUploaded}
          validationSchema={stepThreeValidationSchema}
          initialValues={initialValues}
          onSubmit={stepThreeSubmit}
          validateOnChange
        >
          {initialValues.appType !== "pwa" ? (
            <h4>Upload Build</h4>
          ) : (
            <h4>Submit URL</h4>
          )}
          <div style={{ width: "40%" }}>
            <FormikControl
              control="input"
              type="text"
              maxLen="300"
              urlChecker={true}
              required
              label={
                app.appOS === "ios"
                  ? "App Store URL/Test Flight URL"
                  : "Playstore URL"
              }
              name="playstoreUrl"
              tooltip={
                app.appOS === "ios"
                  ? "Please provide your app store URL/test flight URL"
                  : "Please provide your play store URL."
              }
            />
            <FormikControl
              required={initialValues.appOS === "ios"}
              control="input"
              type="text"
              minL="300"
              label="Deep link"
              name="deepLink"
              tooltip="Please provide the deep link"
            />
            <FormikControl
              maxLen="50"
              control="input"
              type="text"
              label="Build Name"
              name="createRelease.version"
            />
            {initialValues.appType !== "pwa" ? (
              <div style={{ marginBottom: "1em" }}>
                <Field name="createRelease.url">
                  {({ field, form: { setFieldValue } }) => {
                    return (
                      <ApkPicker
                        applicationId={app.id}
                        appOs={app.appOS}
                        text={
                          app.appOS === "ios"
                            ? "+ Upload IPA File"
                            : "+ Upload APK File"
                        }
                        onComplete={(data) => {
                          setFieldValue("createRelease.url", data.url);
                          setFieldValue("createRelease.size", data.size);
                          if (data.url !== "") setApkUploaded(true);
                          else setApkUploaded(false);
                        }}
                      />
                    );
                  }}
                </Field>
              </div>
            ) : (
              <FormikControl
                maxLen="260"
                control="input"
                type="text"
                label="Submit your web application's URL (2048 characters max.)"
                name="createRelease.url"
              />
            )}
            <FormikControl
              maxLen="2000"
              rows="3"
              required
              autoComplete="nope"
              control="textarea"
              type="text"
              label="Release Notes"
              name="createRelease.releaseNote"
            />

            {forceUpdateInfo.showUpdate == "true" && <FormikControl
              control="radio"
              isRow={false}
              options={forceUpdateConst}
              required
              onValChange={(val) => {
                setForceUpdateKey("isForceUpdate", val)
              }}
              label="Choose the app's update type"
              name="createRelease.forceUpdate"
            />}
            {forceUpdateInfo.isForceUpdate == "true" && <FormikControl
              required
              hidden
              inputValue={forceUpdateInfo.minUpdVerCode}
              autoComplete="nope"
              control="input"
              type="text"
              label="App Build Version"
              placeholder="Select the minimum supported app build version"
              onClick={() => { setForceUpdateKey("showPopup", "true") }}
              name="createRelease.appBuildVersion"
            />}
            <div
              style={{
                display: `flex`,
                justifyContent: "flex-start",
                marginTop: "1em",
              }}
            >
              {initialValues.appType !== "pwa" ? (
                <PrimaryButton type="submit" disabled={!apkUploaded}>
                  Publish
                </PrimaryButton>
              ) : (
                <PrimaryButton>Submit URL</PrimaryButton>
              )}
            </div>
          </div>
        </FormikStep>
        {/* Build Status */}
        <FormikStep
          label="Build Status"
          setApkUploaded={setApkUploaded}
          onSubmit={stepFourSubmit}
        >
          <div className={styles.buildstatus}>
            {/* <div className={styles.statusHeading}>
              <span>Build Name</span>
              <span>Status</span>
              <span>Remarks</span>
              <span></span>
              <span></span>
              <span></span>
            </div> */}
            {/* {buildStatusData.map((item, index) => ( */}
            {/* // <div className={styles.statusItem} key={index}> */}
            {/* <span style={{ color: "white" }}>{item.version}</span>
                <>{getStatus(item?.status, appStatus?.release, true)}</>
                <button
                  className={`${
                    item.status === 2
                      ? styles.activeRemark
                      : styles.disabledRemark
                  }`}
                  onClick={() => {
                    setBuild(item);
                    setShowRemarks(item.status === 2);
                  }}
                >
                  Remarks {item?.status}
                </button> */}

            {/* <button
                  onClick={() => handlePublish(item.id)}
                  className={`${styles.publish} ${item.status !== 0 ? 'v-hide' : styles.no_button
                    }`}
                // className={`${item.status === 1
                //     ? styles.unpublish
                //     : item.status === 0
                //         ? styles.publish
                //         : styles.no_button
                //     }`}
                >
                  Submit & Publish
                  {item.status === 0
                                        ? 'Submit & Publish'
                                        : 'Unpublish'}
                </button> */}
            {/* {item.status === appStatus.release.pending.status && (
                  <button
                    onClick={() => handlePublish(item.id)}
                    className={`${styles.publish}`}
                  >
                    {" "}
                    Submit & Publish
                  </button>
                )} */}

            {/* {item.status === appStatus.release.approved.status && <button
                  onClick={() => handlePublish(item.id)}
                  className={`${styles.publish}`}
                > Submit & Publish</button>} */}

            {/* {item.status === 4 && 
                  <button
                  onClick={() => {setShowUnpublishBuild(true)}}
                  className={`${styles.publish}`}
                >Unpublish
                  </button>} */}

            {/* {item.status === appStatus.release.approved.status &&
                  !item.isRollback && (
                    <button
                      onClick={() =>
                        handleRepublish(item.id, publishType.republish)
                      }
                      className={`${styles.publish}`}
                    >
                      {" "}
                      Publish
                    </button>
                  )} */}

            {/* {item.status === appStatus.release.approved.status &&
                  item.isRollback && (
                    <button
                      onClick={() => {
                        setBuild(item);
                        setShowRollbackModal(true);
                      }}
                      // handleRepublish(item.id,publishType.rollback)}
                      className={`${styles.rollback}`}
                    >
                      Roll back
                    </button>
                  )}

                <div className="d-flex" style={{ float: "right" }}>
                  <span
                    style={{
                      opacity: `${
                        item.status === 0
                          ? "1"
                          : item.status === 2
                          ? "1"
                          : "0.5"
                      }`,
                    }}
                    onClick={() => {
                      setBuild(item);
                      setShowDeleteBuild(
                        item.status === 0 || item.status === 2
                      );
                    }}
                  >
                    <img
                      src={deletebtn}
                      style={{
                        height: "2.25em",
                        cursor: "pointer",
                      }}
                      alt="delete button"
                    />
                  </span>
                  <span>
                    <img
                      src={releaseNotes}
                      className="mlc-10"
                      style={{
                        height: "2.25em",
                        cursor: "pointer",
                      }}
                      alt="release notes"
                      onClick={() => {
                        setBuild(item);
                        setShowReleaseNotes(true);
                      }}
                    />
                  </span>
                </div> */}
            {/* </div> */}
            {/* ))} */}
            <table
              className={styles.buildStatusTable}
              style={{ textAlign: "center" }}
            >
              <tr
                style={{
                  height: "50px",
                  borderBottom: "1px solid rgba(110, 110, 110, 1)",
                }}
              >
                <th>Build Name</th>
                <th>Version Code</th>
                <th>Size</th>
                <th>Status</th>
                <th>Created</th>
                <th>Published date</th>
                <th>Devices</th>
                <th>Release notes</th>
                <th>Remarks </th>
                <th>Publish / Rollback</th>
              </tr>
              {buildStatusData?.map((item) => (
                <tr>
                  <td className={styles.tooltip}>
                    {sliceString(0, 10, item.version, true)}
                    {item.version.length > 10 ? (
                      <>
                        <a className="publisher_i_btn">
                          <img
                            data-class="myTooltipClass"
                            data-tip={item.version}
                            src={Info}
                            alt="category-icon"
                          />
                        </a>
                        <ReactTooltip
                          arrowColor="transparent"
                          backgroundColor="#707070"
                          place="right"
                          type="dark"
                          effect="solid"
                          delayShow={100}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </td>

                  <td>{item.packageCode ? item.packageCode : "-"}</td>
                  <td>{Math.ceil(item.size / 1024)} MB</td>
                  <td>{getStatus(item?.status, appStatus?.release, true)}</td>
                  <td>{item.created_at}</td>
                  <td>{item.updated_at}</td>
                  <td
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      gap: "4px",
                      padding: "12px",
                    }}
                  >
                    {item.platform.map((plat) => {
                      let index = configData?.platform?.[app.appOS]?.findIndex(
                        (item) => item.value === plat
                      );
                      if (index > -1) {
                        return (
                          <img
                            src={configData?.platform?.[app.appOS][index]?.icon}
                            style={{ width: "40px", height: "40px" }}
                            alt=""
                          />
                        );
                      }
                    })}
                  </td>
                  <td>
                    <img
                      src={releaseNotes}
                      className="ws-30 c-pointer"
                      onClick={() => {
                        setBuild(item);
                        setShowReleaseNotes(true);
                      }}
                      alt=""
                    />
                  </td>
                  <td>
                    <button
                      className={`btn-tess active`}
                      onClick={() => {
                        setBuild(item);
                        setShowRemarks(item.status === 2);
                      }}
                    >
                      Remarks
                    </button>
                  </td>
                  <td>
                    <>
                      {item.status === appStatus.release.approved.status && (
                        <button
                          onClick={() => {
                            setBuild(item);
                            setShowRollbackModal(true);
                          }}
                          // handleRepublish(item.id,publishType.rollback)}
                          className={`${styles.rollback}`}
                        >
                          Roll back
                        </button>
                      )}

                      {item.status === 0 && (
                        <button
                          onClick={() => handlePublish(item.id)}
                          className={`${styles.publish} ${styles.no_button}`}
                          style={{ marginBottom: 0 }}
                        >
                          Submit and Publish
                        </button>
                      )}
                      <div className="d-flex" style={{ float: "right" }}>
                        <span
                          style={{
                            opacity: `${item.status === 0
                              ? "1"
                              : item.status === 2
                                ? "1"
                                : "0.5"
                              }`,
                          }}
                          onClick={() => {
                            setBuild(item);
                            setShowDeleteBuild(
                              item.status === 0 || item.status === 2
                            );
                          }}
                        >
                          <img
                            src={deletebtn}
                            style={{
                              height: "2.25em",
                              cursor: "pointer",
                            }}
                            alt="delete button"
                          />
                        </span>
                      </div>
                    </>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </FormikStep>
      </FormikStepper>
      {/* <ReactQueryDevtools initialIsOpen /> */}
    </>
  );
}

export function FormikStep({ children }) {
  return <>{children}</>;
}
